import { render, staticRenderFns } from "./HorarioTienda.vue?vue&type=template&id=7aff9b27&"
import script from "./HorarioTienda.vue?vue&type=script&lang=js&"
export * from "./HorarioTienda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports